import { formatDate } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class UtilsService {

  constructor(private http: HttpClient) { }

  convertToHebrewDate(date: Date) {
    let sDate = formatDate(date, 'yyyy-MM-dd', 'en-US');
    let getYear = date.getFullYear()
    let getMonth = date.getMonth()
    let getDay = date.getDay()
    let url = `https://www.hebcal.com/converter?cfg=json&date=${sDate}&g2h=1&strict=1`
    return this.http.get<{ heDateParts:{y:string,m:string,d:string}}>(url)
  }

}
